import React from 'react';
import { Select } from 'antd';
import useClients from './../../hooks/useClients';
import { clientFullName } from './../../utils/client';
import { normalized } from './../../utils/string';

const { Option } = Select;

// Do not overwrite onChange to keep id as value returned.
const ClientSelect = ({ placeholder = "Buscar cliente:", ...restProps }) => {
    const { data, isLoading } = useClients();

    const filterOptionHandler = (input, option) => (normalized(option?.children) ?? '').includes(normalized(input));

    const filterSortHandler = (optionA, optionB) => optionA.children.toLowerCase().localeCompare(optionB.children.toLowerCase());

    return <Select
        {...{ ...restProps, placeholder }}
        loading={isLoading}
        showSearch
        optionFilterProp="children"
        filterOption={filterOptionHandler}
        filterSort={filterSortHandler}>
        {data && data.map((c) => <Option key={c.id} value={c.id}>{c.razonSocial ? c.razonSocial : clientFullName(c)}</Option>)}
    </Select>
}

export default ClientSelect;